import { forwardRef } from "react";

import {
  BLOOD_ICON_TYPE,
  BREATH_ICON_TYPE,
  HAIR_ICON_TYPE,
  NAIL_ICON_TYPE,
  SALIVA_ICON_TYPE,
  STOOL_ICON_TYPE,
  SWAB_ICON_TYPE,
  URINE_ICON_TYPE,
  DETOXIFICATION_METHYLATION_ICON_TYPE,
  ENDOCRINE_ICON_TYPE,
  CARDIOMETABOLIC_ICON_TYPE,
  EXERCISE_ICON_TYPE,
  GASTROENTEROLOGY_ICON_TYPE,
  IMMUNE_ICON_TYPE,
  NEUROCOGNITIVE_ICON_TYPE,
  NUTRITION_ICON_TYPE,
  SIMPLE_DNA_ICON_TYPE
} from "@/core/constants";
import BloodIcon from "@/images/BloodIcon";
import BreathIcon from "@/images/BreathIcon";
import CardiometabolicIcon from "@/images/CardiometabolicIcon";
import DetoxificationMethylationIcon from "@/images/DetoxificationMethylationIcon";
import EndocrineIcon from "@/images/EndocrineIcon";
import ExerciseIcon from "@/images/ExerciseIcon";
import GastroenterologyIcon from "@/images/GastroenterologyIcon";
import HairIcon from "@/images/HairIcon";
import ImmuneIcon from "@/images/ImmuneIcon";
import NailIcon from "@/images/NailIcon";
import NeurocognitiveIcon from "@/images/NeurocognitiveIcon";
import NutritionIcon from "@/images/NutritionIcon";
import SalivaIcon from "@/images/SalivaIcon";
import SimpleDnaIcon from "@/images/SimpleDnaIcon";
import StoolIcon from "@/images/StoolIcon";
import SwabIcon from "@/images/SwabIcon";
import UrineIcon from "@/images/UrineIcon";
import { useTheme } from "styled-components";

const IconType = forwardRef(
  ({ children, iconType, iconSize = [40, 40, 80], withCircle = true, color = "dark" }, ref) => {
    let icon = null;
    const theme = useTheme();

    color = color in theme.colors ? theme.colors[color] : color;

    if (iconType === URINE_ICON_TYPE) {
      icon = <UrineIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === BLOOD_ICON_TYPE) {
      icon = <BloodIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === SALIVA_ICON_TYPE) {
      icon = <SalivaIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === STOOL_ICON_TYPE) {
      icon = <StoolIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === SWAB_ICON_TYPE) {
      icon = <SwabIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === HAIR_ICON_TYPE) {
      icon = <HairIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === BREATH_ICON_TYPE) {
      icon = <BreathIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === NAIL_ICON_TYPE) {
      icon = <NailIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === DETOXIFICATION_METHYLATION_ICON_TYPE) {
      icon = (
        <DetoxificationMethylationIcon size={iconSize} withCircle={withCircle} color={color} />
      );
    } else if (iconType === ENDOCRINE_ICON_TYPE) {
      icon = <EndocrineIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === CARDIOMETABOLIC_ICON_TYPE) {
      icon = <CardiometabolicIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === EXERCISE_ICON_TYPE) {
      icon = <ExerciseIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === GASTROENTEROLOGY_ICON_TYPE) {
      icon = <GastroenterologyIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === IMMUNE_ICON_TYPE) {
      icon = <ImmuneIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === NEUROCOGNITIVE_ICON_TYPE) {
      icon = <NeurocognitiveIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === NUTRITION_ICON_TYPE) {
      icon = <NutritionIcon size={iconSize} withCircle={withCircle} color={color} />;
    } else if (iconType === SIMPLE_DNA_ICON_TYPE) {
      icon = <SimpleDnaIcon size={iconSize} withCircle={withCircle} color={color} />;
    }

    return icon;
  }
);

export default IconType;
